import { createAsyncThunk } from '@reduxjs/toolkit';

import { getErrorMessage } from '@/shared/utils/error';

import { advogadoService } from './services';

interface ListarAdvogadosPayload {
  search?: string;
  especialidade?: string;
  ativo?: boolean;
  page?: number;
  limit?: number;
}

export const listarAdvogados = createAsyncThunk(
  'advogado/listar',
  async (filters: ListarAdvogadosPayload | undefined, { rejectWithValue }) => {
    try {
      return await advogadoService.listar(filters);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const buscarAdvogadoPorId = createAsyncThunk(
  'advogado/buscarPorId',
  async (id: string, { rejectWithValue }) => {
    try {
      return await advogadoService.buscarPorId(id);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const criarAdvogado = createAsyncThunk(
  'advogado/criar',
  async (data: Parameters<typeof advogadoService.criar>[0], { rejectWithValue }) => {
    try {
      return await advogadoService.criar(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const atualizarAdvogado = createAsyncThunk(
  'advogado/atualizar',
  async (
    { id, data }: { id: string; data: Parameters<typeof advogadoService.atualizar>[1] },
    { rejectWithValue },
  ) => {
    try {
      return await advogadoService.atualizar(id, data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const removerAdvogado = createAsyncThunk(
  'advogado/remover',
  async (id: string, { rejectWithValue }) => {
    try {
      await advogadoService.remover(id);
      return id;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
